import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/cadastro`

    const headers = { responseType: "arraybuffer" }

    return {
        relatorioUsuario(queryParms) {
            return repository.get(`${baseUrl}/relatorio-usuario?${urlUtil.serialize(queryParms)}`, headers)
        },
    }
}
